export default {
  async get (data) {
    let r = await fetch(`https://pt.wikipedia.org/w/api.php?format=json&action=query&prop=extracts|pageimages&exintro=&explaintext=&pithumbsize=500&origin=*&titles=${data.text}`).then((r) => r.json()),
      s = r.query.pages,
      l = s[Object.keys(s)[0]],
      txt = l.extract || '',
      img = (l.thumbnail) ? l.thumbnail.source : '';
    if (img) img = `<img src="${img}" height="200" /><br/>`
    return `<div class="pa-4">${img}${txt}</div>`;
  }
};
